document.addEventListener("DOMContentLoaded", function() {
  document.getElementById("smu-price-estimator__extra-fields").addEventListener("input", function(event) {
      if (event.target.id === "thickness") {
        let selectedCoatingType = document.getElementById("coating_type");
        if (!selectedCoatingType) return;
        selectedCoatingType.style.display = (parseFloat(event.target.value) <= 0.022) ? "flex" : "none";
      }
    });

  document.getElementById("product").addEventListener("change", function() {
    getRestOfTheFields(this.value);
  });

  document.getElementById("calculate").addEventListener("click", calculate, false);
  document.getElementById("clear").addEventListener("click", clearForm, false);
});

function getRestOfTheFields(selectedProduct) {
  fetch(`/wp-json/pugpig/steelmarketupdate/product/${selectedProduct}/`)
    .then(response => response.json())
    .then(data => {
      document.getElementById("smu-price-estimator__extra-fields").innerHTML = data;
    });
}

function calculate(event) {
  event.preventDefault();
  let selectedProduct = document.getElementById("product").value;
  let selectedChemistry = document.getElementById("chemistrygrade").value;
  let selectedThickness = document.getElementById("thickness").value;
  let selectedWidth = document.getElementById("width").value;

  let path = `/product/${selectedProduct}/chemistry/${selectedChemistry}/thickness/${selectedThickness}/width/${selectedWidth}`;

  let complexCalculatorProducts = ["Galvanized", "Galvannealed", "Galvalume"];
  if (complexCalculatorProducts.includes(selectedProduct)) {
    let selectedCoatingType = document.querySelector('input[name="coating_type"]:checked').value;
    let selectedCoatingWeight = document.getElementById("coating_weight").value;
    let selectedSurfaceTreatment = document.getElementById("surfacetreatment").value;
    let selectedFinish = document.getElementById("finish").value;
    path += `/coating_type/${selectedCoatingType}/coating_weight/${selectedCoatingWeight}/surfacetreatment/${selectedSurfaceTreatment}/finish/${selectedFinish}`;
  }

  fetch(`/wp-json/pugpig/steelmarketupdate/calculator${path}/`)
    .then(response => response.json())
    .then(data => {
      let resultContainer = document.getElementById("result");
      resultContainer.innerHTML = data[1] ? data[1] : `Estimated Price: <br> $${data[0]} $/cwt`;
    });
}

function clearForm() {
  event.preventDefault();
  let productDropdown = document.getElementById("product");
  productDropdown.value = "Hot_Rolled";
  productDropdown.dispatchEvent(new Event("change"));
  document.getElementById("result").innerText = '';
}
